import React from 'react';
import css from '../../styles.module.css';

const SubSection = ({ name, content }) => {
    return (
        <div className={css['summary-header-subtitle']}>
            <span>{name}</span>
            {content}
        </div>
    );
};

export default SubSection;
